// get
export const FLAG_GETTING_CITIES = 'FLAG_GETTING_CITIES';
export const GET_CITIES = 'GET_CITIES';
export const CLEAR_CITIES = 'CLEAR_CITIES';
export const GET_CITY = 'GET_CITY';
export const CLEAR_CITY = 'CLEAR_CITY';
export const FLAG_CITY_ACTIVITY = 'FLAG_CITY_ACTIVITY';